import api from "../../../config/gatewayConfig";
import { httpClient } from "../../httpClient";
import { parseProductsSearchResponse } from "../../schemas/productsSearchResponseSchema";

export const apiProductsProvider = {
  productsSearch: async (data, requestConfig) => {
    const body = { ...(data && typeof data === "object" ? data : {}), isFromVendor: true };
    const response = await httpClient.post(api.productsSearch, body, {
      headers: { "Content-Type": "application/json" },
      ...(requestConfig && typeof requestConfig === "object" ? requestConfig : {}),
    });
    if (response?.data) {
      response.data = parseProductsSearchResponse(response.data);
    }
    return response;
  },

  categorie: async () => {
    return httpClient.post(api.categorie, null, {
      headers: { "Content-Type": "application/json" },
    });
  },
};


